module.exports = {
  api: {
    token: '747c055d-b73b-33a6-beda-2aa2eced70fb',
  },
};
